import React from "react";
import { Layout as AntLayout } from "antd";
import { SiderProps as AntSiderProps } from "antd/lib/layout";

export const Sider = (props: AntSiderProps) => {
  const { children, ...rest } = props;
  return <AntLayout.Sider {...rest}>{children}</AntLayout.Sider>;
};
